/*
 *
 * WelcomeScreen reducer
 *
 */
import {produce} from 'immer';
import { DEFAULT_ACTION } from './constants';
import * as constants from './constants';

export const initialState = {
    error: 0,
    error_msg: '',
    loading: false,
    user_privileges: ''
};

/* eslint-disable default-case, no-param-reassign */
const WelcomeScreenReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case DEFAULT_ACTION:
        break;
      case constants.UPDATE_INPUT:
        draft[action.name] = action.value;
        break;
      case constants.GET_USER_PRIVILEGES:
        draft.loading = true;
        break;
      case constants.GET_USER_PRIVILEGES_FAIL:
        draft.error = true;
        draft.loading = false;
        break;
      case constants.GET_USER_PRIVILEGES_LOADING:
        draft.loading = true;
        break;
      case constants.GET_USER_PRIVILEGES_SUCCESS:
        draft.user_privileges = action.results;
        draft.loading = false;
        break;
    }
  });

export default WelcomeScreenReducer;
